var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", { attrs: { name: "Billing" } }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: {
                    title: "Pricing Plans",
                    "sub-title": "All Company's Paid Pricing Plans",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header-right",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "mt-n2 d-flex flex-wrap admin-order-filters",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "mt-1 mr-2" },
                                [
                                  _c("div", [_vm._v("Company")]),
                                  _vm._v(" "),
                                  _c("admin-companies-autocomplete", {
                                    staticClass: "mt-1",
                                    model: {
                                      value: _vm.billing_filters.company,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.billing_filters,
                                          "company",
                                          $$v
                                        )
                                      },
                                      expression: "billing_filters.company",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mt-1 mr-2" },
                                [
                                  _c("div", [_vm._v("Pricing Plan")]),
                                  _vm._v(" "),
                                  _c("b-form-select", {
                                    staticClass:
                                      "w-auto mt-1 orders-filter-select",
                                    attrs: {
                                      options: _vm.paidPricingPlanOptions,
                                    },
                                    model: {
                                      value: _vm.billing_filters.pricing_plan,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.billing_filters,
                                          "pricing_plan",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "billing_filters.pricing_plan",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mt-1" },
                                [
                                  _c("div", [_vm._v("Status")]),
                                  _vm._v(" "),
                                  _c("b-form-select", {
                                    staticClass:
                                      "w-auto mt-1 orders-filter-select",
                                    attrs: {
                                      options: _vm.billing_status_options,
                                    },
                                    model: {
                                      value: _vm.billing_filters.status,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.billing_filters,
                                          "status",
                                          $$v
                                        )
                                      },
                                      expression: "billing_filters.status",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c("admin-billing-table", {
                    attrs: { billing: _vm.billing },
                    on: {
                      "retry-payment": _vm.retryPricingPlanPayment,
                      "next-charge-change":
                        _vm.updatePricingPlanPaymentNextChargeDate,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "admin-panel",
                {
                  attrs: {
                    title: "Charges",
                    "sub-title": "All Payments Made",
                    "with-footer": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header-right",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "mt-n2 d-flex flex-wrap admin-order-filters",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "mt-1 mr-2" },
                                [
                                  _c("div", [_vm._v("Company")]),
                                  _vm._v(" "),
                                  _c("admin-companies-autocomplete", {
                                    staticClass: "mt-1",
                                    model: {
                                      value: _vm.charges_filters.company,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.charges_filters,
                                          "company",
                                          $$v
                                        )
                                      },
                                      expression: "charges_filters.company",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mt-1 mr-2" },
                                [
                                  _c("div", [_vm._v("Payment Type")]),
                                  _vm._v(" "),
                                  _c("b-form-select", {
                                    staticClass:
                                      "w-auto mt-1 orders-filter-select",
                                    attrs: { options: _vm.charge_type_options },
                                    on: {
                                      change: function ($event) {
                                        return _vm.loadCharges(1)
                                      },
                                    },
                                    model: {
                                      value: _vm.charges_filters.type,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.charges_filters,
                                          "type",
                                          $$v
                                        )
                                      },
                                      expression: "charges_filters.type",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mt-1" },
                                [
                                  _c("div", [_vm._v("Show")]),
                                  _vm._v(" "),
                                  _c("b-form-select", {
                                    staticClass:
                                      "w-auto mt-1 orders-filter-select",
                                    attrs: {
                                      options: _vm.per_page_select_options,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.loadCharges(1)
                                      },
                                    },
                                    model: {
                                      value: _vm.charges_per_page,
                                      callback: function ($$v) {
                                        _vm.charges_per_page = $$v
                                      },
                                      expression: "charges_per_page",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _vm.total_charges_in_pages > 0
                            ? _c("b-pagination", {
                                staticClass: "admin-pagination mb-0",
                                attrs: {
                                  "total-rows": _vm.total_charges_in_pages,
                                  "per-page": _vm.charges_per_page,
                                  align: "center",
                                },
                                on: { change: _vm.loadCharges },
                                model: {
                                  value: _vm.charges_page,
                                  callback: function ($$v) {
                                    _vm.charges_page = $$v
                                  },
                                  expression: "charges_page",
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-overlay",
                    { attrs: { show: _vm.charges_loading } },
                    [
                      _c("admin-charges-table", {
                        attrs: { charges: _vm.charges },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }